export const BASKET_URL = '/api/proxy/basket';
export const BASKET_LINE_URL = `/api/proxy/basket/line`;
export const BASKET_LINE_MULTI_URL = `/api/proxy/basket/line/multi`;
export const VOUCHER_URL = '/api/proxy/basket/voucher';
export const GIFT_WRAPPING_URL = '/api/proxy/basket/line/{{sku}}/giftwrapping';
export const SUSTAINABLE_PACKAGING_URL = '/api/proxy/basket/line/{{sku}}/sustainablepackaging';
export const BASKET_ABANDONED_GET = '/api/proxy/basket/abandonedBasket/get/{{basketRef}}';
